import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';
import ReplacementProcessCallouts from './ReplacementProcessCallouts';

class LostKeyCombo extends Component {
	render() {
		return (
			<div>
				<Helmet>
					<title>Lost Key or Combination | SentrySafe</title>
					<meta name="description" content="Request a key replacement and a combination recovery for your SentrySafe product with our quick-and-easy replacement and recovery process." />
				</Helmet>

				<Breadcrumb>
                    <BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Lost Key or Combination" path="/support/lost-key-combo"/>
					<BreadcrumbItem label="Select Replacement Process" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Lost Your Key or Combination?"
					description="Select an option below that best describes your needs."
				/>
				<ReplacementProcessCallouts />

			</div>
		);
	}
}

export default LostKeyCombo;


// WEBPACK FOOTER //
// ./src/pages/support/lostKeyCombo/ReplacementProcess.js